import { useSelector } from "react-redux";
import { useEffect } from "react";
import { map } from "./map";
import JDate from "jalali-date";

import { getAngle, timeDuration } from "./utils";

const createRouteArrowsFeaturesDescription = (position) => {
    const insertDate = new Date(position.deviceTime);
    const speed = (position.speed * 1.852).toFixed(2);

    return (
        '<div style="direction: ltr;text-align: right;">' +
        new JDate(insertDate).format("dddd DD MMMM YYYY") +
        "<br />" +
        "ساعت " +
        insertDate.getHours() +
        ":" +
        insertDate.getMinutes() +
        ":" +
        insertDate.getSeconds() +
        "<br />" +
        speed +
        "Km/h" +
        " سرعت" +
        "</div>"
    );
};

const createRouteIconsFeaturesStopsDescription = (event) => {
    const startTime = new Date(event.startTime);
    const duration = timeDuration(event.startTime, event.endTime);

    return (
        '<div style="direction: ltr;text-align: right;">' +
        "توقف در" +
        "<br />" +
        new JDate(startTime).format("dddd DD MMMM YYYY") +
        "<br />" +
        "ساعت " +
        startTime.getHours() +
        ":" +
        startTime.getMinutes() +
        ":" +
        startTime.getSeconds() +
        "<br />" +
        " به مدت " +
        duration +
        "</div>"
    );
};

const createRouteArrowsFeatures = (positions) => {
    let result = [];

    if (positions.length > 2)
        for (let index = 1; index < positions.length - 1; index++) {
            const position = positions[index];
            const rotation = getAngle([position.longitude, position.latitude], [positions[index + 1].longitude, positions[index + 1].latitude]);

            result.push({
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [position.longitude, position.latitude],
                },
                properties: {
                    description: createRouteArrowsFeaturesDescription(position),
                    rotation: rotation,
                },
            });
        }

    return result;
};

const createRouteIconsFeatures = (positions, events) => {
    let result = [];

    new Promise(() => {
        if (positions.length > 1) {
            const lastPositions = positions[positions.length - 1];

            result.push({
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [positions[0].longitude, positions[0].latitude],
                },
                properties: {
                    description: "اولین موقعیت <br />" + createRouteArrowsFeaturesDescription(positions[0]),
                    icon: "start",
                    iconSize: 0.3,
                    offset: [50, -60],
                },
            });

            result.push({
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [lastPositions.longitude, lastPositions.latitude],
                },
                properties: {
                    description: "آخرین موقعیت <br />" + createRouteArrowsFeaturesDescription(lastPositions),
                    icon: "end",
                    iconSize: 0.3,
                    offset: [50, -60],
                },
            });
        }
    });

    for (let index = 0; index < events.length; index++) {
        const event = events[index];

        result.push({
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [event.longitude, event.latitude],
            },
            properties: {
                description: createRouteIconsFeaturesStopsDescription(event),
                icon: "stop",
                iconSize: 0.3,
                offset: [0, -60],
            },
        });
    }

    return result;
};

let is_routesSource_empty = true;
let is_routeArrowsSource_empty = true;
let is_routeIconSource_empty = true;

const Routes = () => {
    const positions = useSelector((state) => state.routes.positions);
    const events = useSelector((state) => state.events.events);

    useEffect(() => {
        if (!positions.length) {
            if (!is_routesSource_empty) {
                is_routesSource_empty = true;

                const routesSource = map.getSource("routes");
                if (!routesSource) return;

                routesSource.setData({
                    type: "Feature",
                    properties: {},
                    geometry: {
                        type: "LineString",
                        coordinates: [],
                    },
                });
            }

            if (!is_routeArrowsSource_empty) {
                is_routeArrowsSource_empty = true;

                const routeArrowsSource = map.getSource("route-arrows");
                if (!routeArrowsSource) return;

                routeArrowsSource.setData({ type: "FeatureCollection", features: [] });
            }

            return;
        }

        const routesSource = map.getSource("routes");
        if (!routesSource) return;

        const routeArrowsSource = map.getSource("route-arrows");
        if (!routeArrowsSource) return;

        is_routesSource_empty = false;

        new Promise(() => {
            routesSource.setData({
                type: "Feature",
                properties: {},
                geometry: {
                    type: "LineString",
                    coordinates: positions.map((position) => [position.longitude, position.latitude]),
                },
            });
        });

        is_routeArrowsSource_empty = false;

        new Promise(() => {
            routeArrowsSource.setData({
                type: "FeatureCollection",
                features: createRouteArrowsFeatures(positions),
            });
        });
    }, [positions]);

    useEffect(() => {
        if (!events.length) {
            if (!is_routeIconSource_empty) {
                is_routeIconSource_empty = true;

                const routeIconSource = map.getSource("route-icons");
                if (!routeIconSource) return;

                routeIconSource.setData({
                    type: "FeatureCollection",
                    features: [],
                });
            }
        }

        const routeIconSource = map.getSource("route-icons");
        if (!routeIconSource) return;

        is_routeIconSource_empty = false;
        routeIconSource.setData({
            type: "FeatureCollection",
            features: createRouteIconsFeatures(positions, events),
        });
    }, [positions, events]);

    return null;
};

export default Routes;
